/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Api key
 */
export interface ApiKeyDto {
  id: number;
  name: string;
  cidr?: string;
  publicKey: string;
  permission: ApiKeyDto.PermissionEnum;
}
export namespace ApiKeyDto {
  export const PermissionEnum = {
    Create: 'CREATE',
    Read: 'READ',
  } as const;
  export type PermissionEnum = (typeof PermissionEnum)[keyof typeof PermissionEnum];
}
